/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";

import { AdContainer } from "../../ads";
import SideBarContent from "../../molecules/sidebar-content";
import LatestNews from "../story-elements/latest-news";
import { WithLazy } from "@quintype/components";

import "./story-sidebar.m.css";

const StorySideBar = ({ story }) => {
  return (
    <div styleName="wrapper">
      <div styleName="ad" className="hide-mobile">
        <AdContainer AdClassName="standard-300x250" id="div-gpt-ad-1675837126868-0" desktop="PV_Desktop_AP_RT" />
      </div>

      <SideBarContent title="ಪ್ರಜಾವಾಣಿ ವಿಡಿಯೊ" speed={2500} state={"video"} />

      <WithLazy margin="300px">{() => <LatestNews story={story} />}</WithLazy>

      {story["story-template"] === "photo" ? (
        <SideBarContent title="ಟ್ರೆಂಡಿಂಗ್ ಫೊಟೋಗಳು" speed={2500} state={"photo"} />
      ) : null}

      <SideBarContent title="ಸಿನಿಮಾ" speed={3000} state={"cinema"} />

      <div styleName="ad" className="hide-mobile">
        <AdContainer AdClassName="standard-300x600" id="div-gpt-ad-1675837205470-0" desktop="PV_Desktop_AP_RM" />
      </div>
    </div>
  );
};

export default StorySideBar;
